var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTrustCheck = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.707 4.293A1 1 0 0 0 .293 5.707l1.414-1.414zM5 9l-.707.707a1 1 0 0 0 1.414 0L5 9zm8.707-7.293A1 1 0 0 0 12.293.293l1.414 1.414zm-13.414 4 4 4 1.414-1.414-4-4L.293 5.707zm5.414 4 8-8L12.293.293l-8 8 1.414 1.414z",
    fill: "#4CA817",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrustCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trust-check.45416311.svg";
export { ForwardRef as ReactComponent };